import api from './Api'

export const getLightBarcodeList = (targetDate: string) => {
    return api.get(`${process.env.REACT_APP_API_DOMAIN}/light-barcode/list/get?targetDate=${targetDate}`);
}

export const updateActiveLightBarcodeList = (targetDate: string, isActive: boolean) => {
    return api.get(`${process.env.REACT_APP_API_DOMAIN}/light-barcode/change/active?targetDate=${targetDate}&isActive=${isActive}`);
}